"use client";
import React from "react";
import Card from "../primitives/card";
// import Form from "../primitives/form";
import * as Form from "@radix-ui/react-form";

export default function ContactFormBasic() {
  const [name, setName] = React.useState<string>("");
  const [email, setEmail] = React.useState<string>("");
  const [subject, setSubject] = React.useState<string>("");
  const [message, setMessage] = React.useState<string>("");
  const [submitting, setSubmitting] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string | null>(null);
  const [submitted, setSubmitted] = React.useState<boolean>(false);
  const disabled =
    submitting ||
    message === "" ||
    email === "" ||
    subject === "" ||
    name === "";

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);

    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}/api/contact`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name,
            email,
            subject,
            message,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit contact form.");
      }

      const result = await response.json();
      console.log("Contact form submitted:", result);
      setName("");
      setEmail("");
      setSubject("");
      setMessage("");
    } catch (err) {
      console.error(err);
      setError("Failed to submit contact form. Please try again.");
    } finally {
      setSubmitting(false);
      setSubmitted(true);
      localStorage.setItem("contactSubmitted", "true");
    }
  };
  return (
    <div className="p-6 bg-white overflow-hidden rounded-lg">
      <div className="text-headline-bold uppercase">Contact Form</div>
      <p className="py-6">
        Fill in the contact form below, and our friendly team will aim to get
        back to you within 72 hours. One small note – if it's a technical issue,
        we'll need to know the type of device (mobile or desktop) and browser
        you're using.
      </p>
      <Form.Root className="flex flex-col w-full gap-7" onSubmit={handleSubmit}>
        <Form.Field name="name" className="relative">
          <Form.Label
            className={`text-secondary text-input top-4 absolute left-4 ${
              name ? "hidden" : "block"
            }`}
          >
            Name <span className="text-error-300 text-sm">*</span>
          </Form.Label>
          <Form.Control asChild>
            <input
              className="w-full border text-input text-dark py-3 px-4 rounded-md flex justify-between items-center outline-none placeholder:text-secondary border-input-grey data-[valid=true]:border-success-300 data-[invalid=true]:border-error-300 hover:border-dark focus:border-dark transition-all duration-100 ease-in-out"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Control>

          <Form.Message match="valueMissing">
            Please fill out this field.
          </Form.Message>
        </Form.Field>
        <Form.Field name="email" className="relative">
        <Form.Label
            className={`text-secondary text-input top-4 absolute left-4 ${
              email ? "hidden" : "block"
            }`}
          >
            Email <span className="text-error-300 text-sm">*</span>
          </Form.Label>
          <Form.Control asChild>
            <input
              className="w-full border text-input text-dark py-3 px-4 rounded-md flex justify-between items-center outline-none placeholder:text-secondary border-input-grey data-[valid=true]:border-success-300 data-[invalid=true]:border-error-300 hover:border-dark focus:border-dark transition-all duration-100 ease-in-out"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Control>

          <Form.Message match="valueMissing">
            Please fill out this field.
          </Form.Message>
        </Form.Field>
        <Form.Field name="subject" className="relative">
        <Form.Label
            className={`text-secondary text-input top-4 absolute left-4 ${
              subject ? "hidden" : "block"
            }`}
          >
            Subject <span className="text-error-300 text-sm">*</span>
          </Form.Label>
          <Form.Control asChild>
            <input
              className="w-full border text-input text-dark py-3 px-4 rounded-md flex justify-between items-center outline-none placeholder:text-secondary border-input-grey data-[valid=true]:border-success-300 data-[invalid=true]:border-error-300 hover:border-dark focus:border-dark transition-all duration-100 ease-in-out"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
          </Form.Control>

          <Form.Message match="valueMissing">
            Please fill out this field.
          </Form.Message>
        </Form.Field>
        <Form.Field name="message" className="relative">
        <Form.Label
            className={`text-secondary text-input top-4 absolute left-4 ${
              message ? "hidden" : "block"
            }`}
          >
            Message <span className="text-error-300 text-sm">*</span>
          </Form.Label>
          <Form.Control asChild>
            <textarea
              rows={4}
              className="w-full border text-input text-dark py-3 px-4 rounded-md flex justify-between items-center outline-none placeholder:text-secondary border-input-grey data-[valid=true]:border-success-300 data-[invalid=true]:border-error-300 hover:border-dark focus:border-dark transition-all duration-100 ease-in-out"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </Form.Control>
          <Form.Message match="valueMissing">
            Please fill out this field.
          </Form.Message>
        </Form.Field>

        {submitted ? (
          <div className="flex flex-row justify-center items-center text-title-sm h-[44px]">
            Thank you for your submission!
          </div>
        ) : (
          <Form.Submit
            disabled={disabled}
            className="btn btn-md btn-filled-primary w-full"
          >
            <span className="w-full text-center">Submit</span>
          </Form.Submit>
        )}
      </Form.Root>
    </div>
  );
}
